<template>
  <div class="case">
    <card-grid
      :data="data"
      @on-delete-click="handleOnDeleteChange"
      @on-preview-click="handleOnPreviewChange"
    >
    </card-grid>
  </div>
</template>

<script>
export default {
  name: 'Case',
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    }
  },
  methods: {
    handleOnDeleteChange (data) {
      this.$emit('on-delete-click', data)
    },
    handleOnPreviewChange (data) {
      this.$emit('on-preview-click', data)
    }
  }
}
</script>
